import {toast, ToastOptions} from "react-toastify";

class AlertService {

    cartProducts: any[] = [];


    constructor() {

    }

    msg = (msg: any, type?:any, onClick?:any) => {

        let options: ToastOptions = {
            type: type??undefined,
            onClick: onClick??undefined
        }

        toast(msg, options);
    }

    error = (msg: any) => {
        let options: ToastOptions = {
            type: 'error'
        }

        if (msg && msg.codigo) {
            if (msg.codigo == 500) {
                toast(msg.message, options);
            }
        } else {
            toast(msg, options);
        }

    }

}


const alertService = new AlertService();

export default alertService;